import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import {
  useGetStatisticsCommunication,
  useGetStatisticsPayrollImport,
} from '@nxsys/hooks/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { useEffect, useMemo, useState } from 'react';
import EmailPayslipModal from './components/EmailPayslipModal';
import { useSelector } from 'react-redux';
import { IRELAND } from '@nxsys/store/constants/keys';
import { AppState } from '@nxsys/store';

const Communication = () => {
  const { payrollCountry, isBureau } = useSelector(
    (state: AppState) => state.appStore,
  );
  // Country-only: mirrors the sibling dashboard widgets (Timesheets.tsx,
  // Payments.tsx). Note this component is only ever mounted from the
  // bureau-only DashboardIreland/DashboardUK (see `if (isBureau) return
  // null;` below, and dashboard/index.tsx's `!isBureau` branch), so this is
  // presently a no-op for reachability, not a live fix.
  const isIreland = payrollCountry === IRELAND;

  const { value, loading, run } = useGetStatisticsCommunication();
  const {
    value: payrollImportValue,
    loading: payrollImportLoading,
    run: payrollImportRun,
  } = useGetStatisticsPayrollImport();

  const data = useMemo(() => {
    if (isIreland) {
      return payrollImportValue?.data;
    } else {
      return value?.data;
    }
  }, [value, payrollImportValue]);
  const [isOpenEmailPayslipModal, setIsOpenEmailPayslipModal] = useState(false);

  useEffect(() => {
    if (isBureau) return;
    if (isIreland) {
      payrollImportRun(undefined);
    } else {
      run();
    }
  }, []);

  if (isBureau) return null;

  const items = [
    {
      title: data?.totalEmailPayslips,
      description: 'Email Payslips',
      onClick: () => setIsOpenEmailPayslipModal(true),
    },
  ];

  return (
    <div className="Communication">
      <AppCard
        className="p-[24px]"
        loading={isIreland ? payrollImportLoading : loading}
      >
        <div className="flex justify-between items-center mb-[24px]">
          <AppIconCard iconName="IconEmail" title="Communication" />
        </div>
        <div className="space-y-[16px]">
          {items.map((item) => (
            <div
              key={item.title}
              className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px] flex items-center w-full gap-x-[12px]"
              onClick={item.onClick}
            >
              <div className="border-[3px] border-warning-300 rounded-full w-[12px] h-[12px]"></div>
              <div className="flex gap-x-[8px] flex-1 items-center">
                <div className="text-[22px] font-bold">{item.title}</div>
                <div className="text-[14px] font-bold">{item.description}</div>
              </div>
              <Icons.IconArrowRight />
            </div>
          ))}
        </div>
      </AppCard>
      <EmailPayslipModal
        isOpen={isOpenEmailPayslipModal}
        toggle={() => setIsOpenEmailPayslipModal(false)}
      />
    </div>
  );
};

export default Communication;
